import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const MemberMobileCard = ({ 
  member, 
  isSelected, 
  onSelect, 
  onEdit, 
  onDelete,
  onViewDetails 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate('/member-details', { state: { memberId: member?.id } });
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      ativo: { bg: 'bg-success', text: 'text-success-foreground', label: 'Ativo' },
      inativo: { bg: 'bg-muted', text: 'text-muted-foreground', label: 'Inativo' },
      pendente: { bg: 'bg-warning', text: 'text-warning-foreground', label: 'Pendente' },
      suspenso: { bg: 'bg-error', text: 'text-error-foreground', label: 'Suspenso' }
    };

    const config = statusConfig?.[status] || statusConfig?.inativo;
    
    return (
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${config?.bg} ${config?.text}`}>
        {config?.label}
      </span>
    );
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-4">
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3 flex-1">
          <Checkbox
            checked={isSelected}
            onChange={(e) => onSelect(member?.id, e?.target?.checked)}
            onClick={(e) => e?.stopPropagation()}
          />
          <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
            <span className="text-sm font-medium text-primary-foreground">
              {member?.name?.split(' ')?.map(n => n?.[0])?.join('')?.substring(0, 2)}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-medium text-foreground truncate">{member?.name}</h3>
            <p className="text-sm text-muted-foreground truncate">{member?.email}</p>
          </div>
        </div>
        {getStatusBadge(member?.status)}
      </div>
      {/* Basic Info */}
      <div className="grid grid-cols-2 gap-3 mb-3 text-sm">
        <div>
          <span className="text-muted-foreground">CPF:</span>
          <span className="ml-2 font-mono text-foreground">{member?.cpf}</span>
        </div>
        <div>
          <span className="text-muted-foreground">Region:</span>
          <span className="ml-2 text-foreground">{member?.region}</span>
        </div>
      </div>
      {/* Expandable Details */}
      {isExpanded && (
        <div className="border-t border-border pt-3 mb-3">
          <div className="grid grid-cols-1 gap-2 text-sm">
            <div>
              <span className="text-muted-foreground">Voter ID:</span>
              <span className="ml-2 font-mono text-foreground">{member?.voterId}</span>
            </div>
            <div>
              <span className="text-muted-foreground">Registration:</span>
              <span className="ml-2 text-foreground">{formatDate(member?.registrationDate)}</span>
            </div>
            <div>
              <span className="text-muted-foreground">Phone:</span>
              <span className="ml-2 text-foreground">{member?.phone}</span>
            </div>
          </div>
        </div>
      )}
      {/* Actions */}
      <div className="flex items-center justify-between pt-3 border-t border-border">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsExpanded(!isExpanded)}
          iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
          iconPosition="right"
        >
          {isExpanded ? 'Less' : 'More'} Details
        </Button>

        <div className="flex items-center space-x-1">
          <Button
            variant="ghost"
            size="sm"
            onClick={(e) => {
              e?.stopPropagation();
              onViewDetails(member);
            }}
            iconName="Eye"
          >
            View
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={(e) => {
              e?.stopPropagation();
              onEdit(member);
            }}
            iconName="Edit"
          >
            Edit
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={(e) => {
              e?.stopPropagation();
              onDelete(member);
            }}
            className="text-error hover:text-error hover:bg-error/10"
            iconName="Trash2"
          />
        </div>
      </div>
    </div>
  );
};

export default MemberMobileCard;